// third-party

// assets
import {
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  LineChartOutlined,
  IdcardOutlined,
  DatabaseOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Indicators: NavItemType = {
  id: 'group-indicators',
  title: 'Indicators',
  icon: icons.IdcardOutlined,
  type: 'group',
  children: [
    {
      id: 'indicators-assets',
      title: 'Assets',
      type: 'collapse',
      icon: icons.FileTextOutlined,
      breadcrumbs: true,
      children: [
        {
          id: 'indicators-karachaganak',
          title: 'Karachaganak',
          type: 'item',
          url: '/indicators/asset/Karachaganak'
        },
        {
          id: 'indicators-tengiz',
          title: 'Tengiz',
          type: 'item',
          url: '/indicators/asset/Tengiz'
        },
        {
          id: 'indicators-kashagan',
          title: 'Kashagan',
          type: 'item',
          url: '/indicators/asset/Kashagan'
        },
        {
          id: 'indicators-kalamkas-offshore',
          title: 'Kalamkas offshore',
          type: 'item',
          url: '/indicators/asset/Kalamkas-offshore'
        }
      ]
    }
  ]
};

export default Indicators;
